import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  COLOR_BLACK,
  COLOR_DARK_GREEN,
  COLOR_DARK_RED,
  COLOR_GREY_10,
} from "shared/theme/colors";

export const StyledComparisonIndicator = styled(Box, {
  shouldForwardProp: (propName: string) =>
    !["isIncreased", "isLowerRatio"].includes(propName),
})<{
  isIncreased: boolean;
  isLowerRatio: boolean;
}>`
  display: flex;
  align-items: center;
  column-gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ isIncreased, isLowerRatio }) =>
    isLowerRatio
      ? COLOR_GREY_10
      : isIncreased
        ? COLOR_DARK_RED
        : COLOR_DARK_GREEN};
`;

export const StyledBlackText = styled(Typography)`
  font-size: 10px;
  color: ${COLOR_BLACK};
`;
